import { useMutation } from "@apollo/client";

import { ProtocolUpdateInput } from "~/__generated__";

import { ProtocolEditRoute_UpdateDocument } from "../mutations.generated";

type ProtocolUpdatePayload = Omit<ProtocolUpdateInput, "protocolId">;

export default function useProtocolEditRoute_Update() {
    const [updateProtocolMutation, { loading, error }] = useMutation(ProtocolEditRoute_UpdateDocument);

    const update = (protocolId: string, data: ProtocolUpdatePayload) =>
        updateProtocolMutation({
            variables: {
                input: { ...data, protocolId },
            },
        });

    return {
        updateProtocol: update,
        loading,
        error,
    };
}
